import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=48670c88&scoped=true&"
import script from "./TaskRow.vue?vue&type=script&lang=js&"
export * from "./TaskRow.vue?vue&type=script&lang=js&"
import style0 from "./TaskRow.vue?vue&type=style&index=0&id=48670c88&lang=less&scoped=true&"
import style1 from "./TaskRow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48670c88",
  null
  
)

export default component.exports